import React, { useState } from 'react'
import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { ConvertFailedResponse } from '../../models/Construction'
import { formatOrdinals } from '../../utils/Common'
import { setConvertFixes } from '../../actions/files'
import { useDispatch } from 'react-redux'

interface UploadConvertIssuesProps {
  issues: ConvertFailedResponse
  handleConvertTo3DClick: () => void
}

const UploadConvertIssuesComponent: React.FC<UploadConvertIssuesProps> = ({
  issues,
  handleConvertTo3DClick,
}) => {
  const dispatch = useDispatch()
  const [selectedStoreyIndex, setSelectedStoreyIndex] = useState(0)
  const [selectedImages, setSelectedImages] = useState<{
    [key: number]: string
  }>({})
  const values = Object.keys(issues.details)
  const isSelectedLastStorey = values.length - 1 === selectedStoreyIndex

  const handleButtonClick = () => {
    if (!isSelectedLastStorey) {
      setSelectedStoreyIndex(selectedStoreyIndex + 1)
    } else {
      dispatch(setConvertFixes(selectedImages))
      handleConvertTo3DClick()
    }
  }

  const handleImageClick = (storeyIndex: number, imageName: string) => {
    setSelectedImages((prevState) => ({
      ...prevState,
      [storeyIndex]: imageName,
    }))
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        pl: '3.3rem',
        pr: '1rem',
      }}
    >
      <Stack width='100%' gap='1rem'>
        <Typography
          sx={{
            color: '#04002E',
            fontSize: '0.94rem',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          Help Us Best Match Your Floor Plan
        </Typography>
        <Typography
          sx={{
            color: '#04002E',
            fontSize: '0.8rem',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          Select the image that looks as closest as your floor plan like your
          floor plan
        </Typography>
        <Box display='flex' flexDirection={'column'} gap='0.4rem'>
          <Box
            width='8rem'
            height='4.5rem'
            borderRadius='0.4rem'
            sx={{ background: '#F5F5F5' }}
          ></Box>
          <Typography
            sx={{
              color: '#797979',
              fontSize: '0.64rem',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            Example image
          </Typography>
        </Box>
        <Box display='flex' flexDirection={'column'} gap='0.75rem' mt='1rem'>
          <Box display='flex' gap='1rem'>
            {Object.keys(issues.details).map((storeyIndex) => (
              <Typography
                key={Number(storeyIndex)}
                sx={{
                  color:
                    selectedStoreyIndex === Number(storeyIndex)
                      ? '#1705E5'
                      : '04002E',
                  fontSize: '0.72rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                  borderBottom:
                    selectedStoreyIndex === Number(storeyIndex)
                      ? '1px solid #1705E5'
                      : '1px solid transparent',
                }}
              >
                {formatOrdinals(Number(storeyIndex) + 1, true)} floor
              </Typography>
            ))}
          </Box>
          <Grid container spacing='1rem'>
            {issues.details[selectedStoreyIndex].map((storeyData, index) => (
              <Grid key={index} size={6}>
                <Box
                  component='img'
                  src={storeyData.image}
                  onClick={() =>
                    handleImageClick(selectedStoreyIndex, storeyData.name)
                  }
                  width='100%'
                  height='14rem'
                  borderRadius='0.4rem'
                  sx={{
                    border:
                      selectedImages[selectedStoreyIndex] === storeyData.name
                        ? '2px solid #1705E5'
                        : '2px solid #F5F5F5',
                  }}
                ></Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
      <Box
        sx={{
          ml: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant='contained'
          disabled={!selectedImages[selectedStoreyIndex]}
          onClick={handleButtonClick}
          sx={{
            background: '#56003D',
            color: 'white',
            textTransform: 'capitalize',
            width: '110px',
            fontSize: '12px',
            pl: '10px',
            pr: '10px',
            '&:hover': {
              backgroundColor: '#56003D',
            },
          }}
        >
          {!isSelectedLastStorey
            ? `${formatOrdinals(selectedStoreyIndex + 2)} Floor`
            : 'Convert to 3D'}
        </Button>
      </Box>
    </Box>
  )
}

export default UploadConvertIssuesComponent
